export { CollapsibleCard } from './CollapsibleCard';
export type { CollapsibleCardProps } from './types';
